const SubAbas = [{ label: 'Estabelecimento de Saúde', rota: '/daf/ses/ses' }];

export default SubAbas;
